import { render, staticRenderFns } from "./CollaborationBrowsing.vue?vue&type=template&id=61dd0c11&scoped=true"
import script from "./CollaborationBrowsing.vue?vue&type=script&lang=js"
export * from "./CollaborationBrowsing.vue?vue&type=script&lang=js"
import style0 from "./CollaborationBrowsing.vue?vue&type=style&index=0&id=61dd0c11&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd0c11",
  null
  
)

export default component.exports